module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Medium-WebS.4c86270c.eot";